// Firebase Configuration (web)
// Web app initialises Firebase with browser persistence and hands the instances
// to @3dera/core so all services share the same configured clients.
import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initCore } from '@3dera/core/firebase';

const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId,
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    (projectId ? `${projectId}.appspot.com` : undefined),
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error('Firebase configuration is missing. Please check your .env file.');
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// 🔧 Yerel geliştirme: VITE_USE_EMULATOR=true ise Firebase emülatörlerine bağlan.
// Üretimi ETKİLEMEZ (yalnız bayrak açıkken). Portlar firebase.json ile eşleşir.
// Kullanım: `firebase emulators:start` + `VITE_USE_EMULATOR=true pnpm --filter @3dera/web dev`
if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  const host = '127.0.0.1';
  try {
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, host, 8080);
    connectStorageEmulator(storage, host, 9199);
    connectFunctionsEmulator(functions, host, 5001);
    // eslint-disable-next-line no-console
    console.info('🔧 Firebase emülatörlerine bağlanıldı (yerel test modu).');
  } catch (e) {
    console.error('Emülatör bağlantısı kurulamadı:', e);
  }
}

// Oturum kalıcılığı: tarayıcı kapatılsa bile giriş korunur.
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Persistence ayarlanamadı:', error);
});

// @3dera/core servislerinin bu instances'ı görmesi için inject ediyoruz.
initCore({
  app,
  auth,
  db,
  storage,
  functions,
  env: {
    GEMINI_API_KEY: import.meta.env.VITE_GEMINI_API_KEY,
    MESHY_API_KEY: import.meta.env.VITE_MESHY_API_KEY,
  },
});

export default app;
